// extracted by mini-css-extract-plugin
module.exports = {"details":"DetailsIBO_details__3Mx23"};